var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 500,
    viewBox: "0 0 750 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.846 100.319C560.846 100.319 500.985 31.5551 443.307 20.0681C385.629 8.5811 301.388 28.8971 269.68 70.0721C237.972 111.247 164.913 93.2981 101.851 127.759C38.7902 162.22 5.34122 228.723 20.7222 288.312C36.1032 347.901 75.7052 360.37 95.7002 386.934C115.695 413.498 202.597 488.163 311.032 478.112C419.467 468.061 436.386 433.6 493.295 442.933C550.204 452.266 637.875 481.702 688.632 419.959C739.389 358.216 695.81 358.384 715.806 298.795C735.801 239.206 732.201 190.142 706.823 149.938C681.444 109.733 580.072 119.703 560.846 100.319Z",
    fill: "#3DE96E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M560.846 100.319C560.846 100.319 500.985 31.5551 443.307 20.0681C385.629 8.5811 301.388 28.8971 269.68 70.0721C237.972 111.247 164.913 93.2981 101.851 127.759C38.7902 162.22 5.34122 228.723 20.7222 288.312C36.1032 347.901 75.7052 360.37 95.7002 386.934C115.695 413.498 202.597 488.163 311.032 478.112C419.467 468.061 436.386 433.6 493.295 442.933C550.204 452.266 637.875 481.702 688.632 419.959C739.389 358.216 695.81 358.384 715.806 298.795C735.801 239.206 732.201 190.142 706.823 149.938C681.444 109.733 580.072 119.703 560.846 100.319Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M714.524 437.997H724.505",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8682 437.997H705.908",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M620.807 173.256C620.807 173.256 619.502 164.122 608.628 161.077C597.754 158.032 592.969 173.256 590.359 174.561C587.749 175.866 583.834 167.166 576.875 168.036C569.916 168.906 569.481 178.041 568.176 179.345C566.871 180.65 562.956 175.865 559.041 178.475C555.126 181.085 554.256 184.13 554.256 184.13L545.122 187.61H644.731C644.731 187.61 643.861 178.041 637.337 174.561C630.812 171.081 627.333 174.996 625.158 175.431C622.982 175.866 620.807 173.256 620.807 173.256Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.75 275.425C388.75 275.425 387.445 266.291 376.571 263.246C365.697 260.201 360.912 275.425 358.302 276.73C355.692 278.035 351.777 269.335 344.818 270.205C337.858 271.075 337.423 280.209 336.119 281.514C334.814 282.819 330.899 278.034 326.985 280.644C323.07 283.254 322.2 286.299 322.2 286.299L313.066 289.779H412.675C412.675 289.779 411.805 280.21 405.28 276.73C398.755 273.25 395.276 277.165 393.101 277.6C390.925 278.035 388.75 275.425 388.75 275.425Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 157.245C209.221 157.245 207.032 141.92 188.788 136.812C170.544 131.704 162.517 157.245 158.138 159.434C153.759 161.623 147.192 147.028 135.515 148.488C123.839 149.947 123.109 165.272 120.92 167.461C118.731 169.65 112.163 161.623 105.595 166.001C99.0272 170.379 97.5682 175.488 97.5682 175.488L82.2432 181.326H249.356C249.356 181.326 247.897 165.272 236.95 159.434C226.004 153.596 220.166 160.164 216.517 160.894C212.87 161.623 209.221 157.245 209.221 157.245Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.982 24.7378C300.572 24.8638 237.859 84.4638 237.859 157.974C237.859 158.343 237.861 158.71 237.864 159.076C238.208 199.064 271.464 231.19 311.441 230.193C317.65 230.038 324.272 230.357 330.895 231.425C344.144 233.562 354.4 241.333 361.353 250.316C365.195 255.279 370.968 258.413 377.244 258.436C377.49 258.437 377.736 258.437 377.983 258.438C378.229 258.438 378.476 258.437 378.722 258.436C384.998 258.413 390.771 255.279 394.613 250.316C401.566 241.334 411.822 233.562 425.071 231.425C431.694 230.357 438.316 230.038 444.525 230.193C484.502 231.19 517.758 199.064 518.102 159.076C518.105 158.71 518.107 158.342 518.107 157.974C518.105 84.4638 455.392 24.8628 377.982 24.7378Z",
    fill: "#3DE96E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M426.452 188.48L395.457 195.181L432.445 149.097L381.933 196.185L381.622 199.448L379.365 149.953L375.798 228.129L325.991 181.698L362.98 227.783L331.984 221.081L371.168 237.984L375.124 242.913L368.235 437.997H390.494L382.182 211.72L387.269 205.382L426.452 188.48Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350.125 143.077C350.125 143.077 346.965 134.049 340.194 130.889C333.423 127.729 328.909 126.826 328.909 126.826C328.909 126.826 332.521 145.334 350.125 143.077Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M300.316 107.636C300.316 107.636 297.156 98.6078 290.385 95.4478C283.614 92.2878 279.1 91.3848 279.1 91.3848C279.1 91.3848 282.711 109.893 300.316 107.636Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M358.302 119.081C358.302 119.081 357.782 109.53 352.159 104.61C346.536 99.6889 342.452 97.5649 342.452 97.5649C342.452 97.5649 340.766 116.346 358.302 119.081Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M433.538 192.214C433.538 192.214 427.481 184.812 420.037 184.159C412.594 183.506 408.043 184.202 408.043 184.202C408.043 184.202 417.768 200.357 433.538 192.214Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M439.285 215.682C439.285 215.682 433.228 208.28 425.784 207.627C418.341 206.974 413.79 207.67 413.79 207.67C413.79 207.67 423.515 223.824 439.285 215.682Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315.326 189.953C315.326 189.953 321.383 182.55 328.827 181.898C336.27 181.245 340.821 181.941 340.821 181.941C340.821 181.941 331.097 198.095 315.326 189.953Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.422 211.026C290.422 211.026 296.479 203.624 303.923 202.971C311.366 202.318 315.917 203.014 315.917 203.014C315.917 203.014 306.192 219.169 290.422 211.026Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M331.67 110.956C331.67 110.956 331.15 101.405 325.527 96.4849C319.904 91.5639 315.82 89.4399 315.82 89.4399C315.82 89.4399 314.133 108.221 331.67 110.956Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M420.144 116.373C420.144 116.373 420.664 106.822 426.287 101.902C431.91 96.9809 435.994 94.8569 435.994 94.8569C435.994 94.8569 437.68 113.637 420.144 116.373Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.098 104.087C376.098 104.087 381.614 96.2719 380.254 88.9249C378.895 81.5779 377.009 77.3779 377.009 77.3779C377.009 77.3779 364.038 91.0639 376.098 104.087Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M382.241 140.044C382.241 140.044 383.137 130.521 378.302 124.824C373.467 119.127 369.742 116.423 369.742 116.423C369.742 116.423 365.3 134.749 382.241 140.044Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M359.521 96.5409C359.521 96.5409 362.377 87.4119 358.832 80.8349C355.287 74.2569 352.205 70.8379 352.205 70.8379C352.205 70.8379 344.052 87.8399 359.521 96.5409Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M335.914 80.7251C335.914 80.7251 337.072 71.2301 332.396 65.4021C327.72 59.5741 324.071 56.7681 324.071 56.7681C324.071 56.7681 319.126 74.9651 335.914 80.7251Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.743 167.411C366.743 167.411 369.599 158.282 366.054 151.705C362.509 145.127 359.428 141.708 359.428 141.708C359.428 141.708 351.274 158.71 366.743 167.411Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M388.14 156.69C388.14 156.69 396.219 151.57 397.766 144.26C399.312 136.95 399.171 132.349 399.171 132.349C399.171 132.349 381.96 140.052 388.14 156.69Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M389.1 96.5409C389.1 96.5409 386.244 87.4119 389.789 80.8349C393.334 74.2569 396.415 70.8379 396.415 70.8379C396.415 70.8379 404.57 87.8399 389.1 96.5409Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M382.629 64.1469C382.629 64.1469 377.437 56.1138 379.095 48.8279C380.753 41.5419 382.809 37.4229 382.809 37.4229C382.809 37.4229 395.211 51.6279 382.629 64.1469Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M400.364 119.491C400.364 119.491 408.423 114.34 409.942 107.024C411.46 99.7079 411.301 95.1069 411.301 95.1069C411.301 95.1069 394.12 102.877 400.364 119.491Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M426.227 78.302C426.227 78.302 434.286 73.151 435.805 65.835C437.323 58.519 437.164 53.918 437.164 53.918C437.164 53.918 419.982 61.688 426.227 78.302Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M422.1 144.491C422.1 144.491 431.359 142.091 435.069 135.605C438.78 129.119 440.053 124.696 440.053 124.696C440.053 124.696 421.311 126.76 422.1 144.491Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M456.583 120.065C456.583 120.065 465.842 117.665 469.552 111.179C473.262 104.693 474.536 100.27 474.536 100.27C474.536 100.27 455.794 102.334 456.583 120.065Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M424.178 166.82C424.178 166.82 432.864 170.826 439.842 168.157C446.821 165.488 450.608 162.871 450.608 162.871C450.608 162.871 434.797 152.598 424.178 166.82Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M461.971 168.466C461.971 168.466 468.568 175.392 476.039 175.484C483.51 175.576 487.996 174.54 487.996 174.54C487.996 174.54 477.085 159.161 461.971 168.466Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M447.236 187.186C447.236 187.186 452.45 195.205 459.778 196.666C467.106 198.127 471.705 197.932 471.705 197.932C471.705 197.932 463.801 180.812 447.236 187.186Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M436.366 146.507C436.366 146.507 445.052 150.513 452.03 147.843C459.009 145.174 462.796 142.557 462.796 142.557C462.796 142.557 446.984 132.285 436.366 146.507Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M472.765 141.238C472.765 141.238 481.451 145.244 488.429 142.575C495.408 139.905 499.195 137.289 499.195 137.289C499.195 137.289 483.383 127.016 472.765 141.238Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M314.772 159.483C314.772 159.483 320.607 167.062 328.028 167.936C335.449 168.81 340.018 168.249 340.018 168.249C340.018 168.249 330.777 151.812 314.772 159.483Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M295.814 133.302C295.814 133.302 301.649 140.881 309.07 141.755C316.491 142.629 321.06 142.068 321.06 142.068C321.06 142.068 311.819 125.631 295.814 133.302Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M253.225 141.806C253.225 141.806 261.168 147.135 268.481 145.604C275.794 144.072 279.948 142.088 279.948 142.088C279.948 142.088 265.959 129.443 253.225 141.806Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M271.439 171.345C271.439 171.345 278.692 177.58 286.136 176.928C293.579 176.276 297.939 174.798 297.939 174.798C297.939 174.798 285.552 160.582 271.439 171.345Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M419.139 324.621L413.996 378.388C413.996 378.388 411.095 386.548 411.095 387.092C411.095 387.636 407.831 421.002 407.831 421.002C407.831 421.002 404.93 422.634 405.292 423.722C405.655 424.81 407.105 430.794 407.105 430.794C407.105 430.794 404.022 439.861 404.022 440.586C404.022 441.311 410.187 441.674 412.001 441.493C413.814 441.312 416.534 442.037 417.441 439.498C418.348 436.959 419.073 431.338 419.073 431.338L424.876 423.541L423.063 415.018L431.767 369.14L439.564 350.1L444.641 350.281L446.454 392.713C446.454 392.713 442.283 417.737 443.734 420.276C445.185 422.815 446.454 429.705 446.454 429.705V435.145C446.454 435.145 446.091 437.684 447.361 438.772C448.63 439.86 459.873 439.679 460.961 439.86C462.049 440.041 468.033 440.948 469.484 440.585C470.935 440.222 474.199 438.59 473.473 437.14C472.748 435.689 466.582 432.969 464.95 431.519C463.318 430.068 461.142 425.716 461.142 425.716C461.142 425.716 462.23 417.375 462.411 416.105C462.592 414.836 462.23 410.121 462.23 407.945C462.23 405.769 467.126 379.657 467.126 376.755C467.126 373.854 466.401 337.587 466.401 337.587L419.139 324.621Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M407.105 430.794C407.105 430.794 404.022 439.861 404.022 440.586C404.022 441.311 410.187 441.674 412.001 441.493C413.814 441.312 416.534 442.037 417.441 439.498C418.348 436.959 419.073 431.338 419.073 431.338C419.073 431.338 412.281 428.693 410.455 428.693C408.63 428.694 407.105 430.794 407.105 430.794Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M469.484 440.586C470.935 440.223 474.199 438.591 473.473 437.141C472.748 435.69 466.582 432.97 464.95 431.52C464.417 431.046 463.826 430.261 463.271 429.42L462.257 429.835C462.257 429.835 451.759 431.889 448.793 432.117C447.579 432.21 446.877 432.264 446.454 432.297V435.147C446.454 435.147 446.091 437.686 447.361 438.774C448.63 439.862 459.873 439.681 460.961 439.862C462.05 440.043 468.034 440.949 469.484 440.586Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M477.367 243.844C477.367 243.844 474.124 245.543 472.888 246.47C471.652 247.397 462.385 248.015 456.516 248.015C450.647 248.015 442.461 254.965 440.917 258.672C439.372 262.379 419.14 324.622 419.14 324.622L465.475 339.295L478.758 297.593L480.611 294.195L480.765 304.389C480.765 304.389 489.414 305.934 490.804 305.625C492.194 305.316 494.511 305.316 494.511 305.316L496.364 285.238C496.364 285.238 495.901 278.597 494.047 271.801C492.194 265.005 488.95 259.136 488.95 259.136L484.78 251.105L486.016 243.074C486.016 243.072 480.765 241.218 477.367 243.844Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M484.78 251.103L486.016 243.072C486.016 243.072 480.765 241.219 477.367 243.844C477.367 243.844 474.124 245.543 472.888 246.47C472.3 246.911 469.889 247.28 466.897 247.548C467.203 248.931 469.72 259.515 475.205 260.525C480.011 261.41 485.639 257.743 487.523 256.384L484.78 251.103Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M503.778 241.991C503.778 241.991 506.095 241.528 506.249 239.829C506.404 238.13 506.558 233.188 499.453 228.091C492.348 222.994 487.715 222.531 481.537 226.855C475.359 231.18 475.513 240.447 475.822 241.837C476.131 243.227 476.285 244.154 477.366 243.845C478.447 243.536 480.764 241.683 480.764 241.683C480.764 241.683 485.243 245.699 492.811 246.008C500.38 246.315 503.778 241.991 503.778 241.991Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M503.778 241.991C503.778 241.991 501.461 250.486 500.38 250.949C499.299 251.412 498.527 251.103 497.909 251.567C497.291 252.03 496.519 256.973 496.056 257.282C495.593 257.591 492.967 258.054 492.967 258.054C492.967 258.054 488.797 260.062 488.642 260.68C488.487 261.298 488.642 262.533 487.714 262.688C484.321 263.252 480.087 258.958 478.602 256.201C477.521 254.193 479.838 247.088 479.838 247.088C479.838 247.088 477.676 242.3 478.602 239.366C479.529 236.431 482.154 235.35 483.235 236.586C484.316 237.822 484.78 241.528 484.78 241.528L486.016 243.072L488.951 242.3C488.951 242.3 493.276 243.844 496.519 243.227C499.762 242.608 503.778 241.991 503.778 241.991Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M479.838 247.087L478.372 253.594C478.269 254.681 478.302 255.64 478.603 256.199C480.088 258.956 484.322 263.25 487.715 262.686C488.643 262.531 488.488 261.296 488.643 260.678C488.797 260.06 492.968 258.052 492.968 258.052C492.968 258.052 493.365 257.982 493.875 257.878L493.586 256.97C493.586 256.97 492.196 254.962 489.879 254.808C487.562 254.654 483.547 252.955 483.547 252.955L486.018 243.07L484.782 241.526L482.311 245.233L479.838 247.087Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M496.673 250.176C496.673 250.176 495.592 248.786 493.43 248.786",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M495.437 251.412L494.665 252.802C494.665 252.802 492.812 252.802 492.194 251.412",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M488.333 257.59C488.333 257.59 486.788 256.972 486.788 255.119",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M480.61 294.195C480.61 294.195 486.633 285.546 487.56 281.067L480.61 294.195Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M480.61 294.195C480.61 294.195 486.633 285.546 487.56 281.067",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M482.178 305.13C482.178 305.13 481.271 316.554 481.271 325.802C481.271 335.05 478.551 343.936 478.551 343.936L477.463 346.475C477.463 346.475 479.095 353.728 479.095 356.811C479.095 359.894 478.188 364.064 478.188 364.064C478.188 364.064 482.903 356.085 483.265 353.184C483.628 350.283 484.353 343.392 484.353 343.392C484.353 343.392 492.876 315.285 492.876 313.472C492.876 311.659 492.876 305.493 492.876 305.493C492.876 305.493 483.991 304.948 482.178 305.13Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M473.835 370.256C473.518 370.256 473.197 370.174 472.904 370.002C472.028 369.488 471.735 368.359 472.249 367.483C474.271 364.042 475.34 360.1 475.34 356.084C475.34 343.656 465.229 333.545 452.801 333.545C440.373 333.545 430.262 343.656 430.262 356.084C430.262 357.551 430.403 359.017 430.683 360.443C430.878 361.44 430.228 362.407 429.231 362.602C428.234 362.806 427.267 362.148 427.071 361.15C426.746 359.493 426.581 357.788 426.581 356.084C426.581 341.626 438.343 329.864 452.801 329.864C467.259 329.864 479.021 341.626 479.021 356.084C479.021 360.756 477.777 365.342 475.423 369.347C475.08 369.931 474.466 370.256 473.835 370.256Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M448.711 336.659L421.894 357.74C420.634 358.73 420.41 360.552 421.392 361.818L442.902 389.563C443.87 390.812 445.656 391.062 446.93 390.128L474.834 369.665C476.169 368.686 476.422 366.792 475.39 365.497L452.792 337.133C451.794 335.88 449.971 335.668 448.711 336.659Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M454.434 249.097C454.434 249.097 447.543 248.553 443.191 252.542C438.839 256.531 431.042 278.654 431.042 278.654L445.911 285.001L452.62 273.758",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M454.434 249.097C454.434 249.097 447.543 248.553 443.191 252.542C438.839 256.531 431.042 278.654 431.042 278.654L445.911 285.001L452.62 273.758",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M431.042 278.655L427.415 295.7L451.17 325.258L452.802 329.429C452.802 329.429 456.61 333.962 456.791 334.506C456.972 335.05 459.33 336.319 461.324 336.319C463.319 336.319 465.313 335.775 465.313 335.775C465.313 335.775 466.401 338.495 467.489 337.226C468.577 335.957 468.577 332.693 468.214 330.517C467.851 328.341 468.758 325.984 466.582 323.989C464.406 321.994 460.779 320.362 459.51 320C458.241 319.637 441.014 292.618 441.014 292.618L444.459 283.914L431.042 278.655Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M502.59 402.79C502.59 402.79 516.671 412.295 522.303 432.008",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M508.926 398.213C508.926 398.213 521.599 404.902 527.583 415.11",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M511.742 391.525C511.742 391.525 521.951 395.749 525.471 400.678",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M467.852 374.944L474.38 382.741L508.834 388.362C508.834 388.362 508.834 392.17 506.839 395.434C504.844 398.698 499.404 401.781 499.404 401.781L494.327 391.264L450.988 387.093L467.852 374.944Z",
    fill: "#3DE96E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M304.392 355.077L295.857 371.486C295.857 371.486 277.067 376.405 272.017 377.527C266.968 378.649 263.543 377.939 263.543 377.939L255.745 376.884C255.745 376.884 248.028 381.396 247.569 381.64C247.11 381.884 247.2 382.771 248.362 382.743C249.524 382.715 251.576 381.556 251.576 381.556C251.576 381.556 247.932 383.629 248.206 384.211C248.48 384.793 249.366 385.223 250.162 384.765C250.958 384.308 254.263 383.488 254.263 383.488C254.263 383.488 249.637 387.364 251.38 387.581C253.123 387.798 254.81 385.691 254.81 385.691C254.81 385.691 253.031 388.471 254.255 388.168C255.479 387.865 257.899 386.095 257.899 386.095C257.899 386.095 263.742 385.556 265.762 385.315C267.781 385.074 269.435 383.884 269.435 383.884C269.435 383.884 282.711 383.451 288.188 382.483C293.665 381.515 300.581 380.06 301.286 379.235C301.991 378.41 313.073 358.121 313.073 358.121L304.392 355.077Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M258.679 378.236C258.679 378.236 252.342 380.977 251.576 381.556C250.81 382.136 250.349 383.419 251.786 383.453C253.224 383.486 258.151 381.875 258.151 381.875C258.151 381.875 260.41 384.173 263.258 382.558C266.106 380.942 266.106 380.942 266.106 380.942",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M308.279 415.25L311.684 428.745C311.684 428.745 306.513 432.276 305.126 433.033C303.739 433.79 298.694 435.051 297.433 435.555C296.172 436.059 295.289 437.321 296.802 438.203C298.315 439.086 306.261 439.716 309.792 439.59C313.323 439.464 318.62 438.833 318.62 438.833C318.62 438.833 323.791 438.833 324.295 437.698C324.8 436.563 324.421 432.653 323.412 431.392C322.403 430.131 320.637 427.104 320.385 425.843C320.133 424.582 318.998 417.015 318.998 417.015L308.279 415.25Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M324.296 437.699C324.801 436.564 324.422 432.654 323.413 431.393C323.207 431.136 322.966 430.793 322.717 430.419C319.779 431.746 313.576 432.024 313.576 432.024C313.576 432.024 313.071 430.511 312.945 429.754C312.819 428.997 311.684 428.745 311.684 428.745C311.684 428.745 306.513 432.276 305.126 433.033C303.739 433.79 298.694 435.051 297.433 435.555C296.172 436.059 295.289 437.321 296.802 438.203C298.315 439.086 306.261 439.716 309.792 439.59C313.323 439.464 318.62 438.833 318.62 438.833C318.62 438.833 323.791 438.834 324.296 437.699Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M339.304 422.313L347.123 425.592C347.123 425.592 347.249 429.249 345.61 432.15C343.971 435.051 342.962 437.195 341.07 438.204C339.178 439.213 337.16 440.726 338.422 441.735C339.683 442.744 351.664 442.618 353.052 442.113C354.439 441.609 358.727 435.05 359.736 433.285C360.745 431.519 362.384 426.096 361.754 425.34C361.123 424.583 357.592 420.674 357.592 420.674L356.457 420.043L342.08 418.025L339.304 422.313Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M361.753 425.34C361.122 424.583 357.591 420.674 357.591 420.674L356.456 420.043L356.373 420.031C356.349 421.027 356.33 422.101 356.33 422.943C356.33 425.087 353.682 427.609 353.682 427.609C353.682 427.609 351.538 426.096 349.016 425.213C346.494 424.33 347.124 425.591 347.124 425.591C347.124 425.591 347.25 429.248 345.611 432.149C343.972 435.05 342.963 437.194 341.071 438.203C339.179 439.212 337.161 440.725 338.423 441.734C339.684 442.743 351.665 442.617 353.053 442.112C354.44 441.608 358.728 435.049 359.737 433.284C360.744 431.52 362.383 426.096 361.753 425.34Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M331.737 388.387L330.98 390.657C330.98 390.657 321.269 383.342 311.558 379.937C301.847 376.532 294.532 375.775 291.757 379.432C288.982 383.089 290.748 390.657 293.523 394.44C296.298 398.224 303.234 416.258 303.234 416.258L307.396 416.51L311.684 420.041C311.684 420.041 324.674 423.068 326.188 423.698C327.701 424.329 336.025 428.49 336.025 428.49C336.025 428.49 339.935 425.085 341.07 423.571C342.205 422.058 343.845 418.526 343.845 418.526L358.601 420.166C358.601 420.166 365.537 414.869 366.42 406.798C367.303 398.726 365.789 393.177 364.907 391.79C364.024 390.403 362.132 387.376 362.132 387.376L360.619 385.484L331.737 388.387Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M355.536 404.534C356.688 405.124 357.842 405.792 358.978 406.548",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M306.135 414.367C306.135 414.367 302.604 409.953 304.369 406.548C306.135 403.143 327.07 398.981 339.556 400.116C339.556 400.116 346.271 400.362 353.63 403.624",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M341.574 399.233C341.574 399.233 349.772 398.729 358.095 399.99",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M331.989 391.666C331.989 391.666 336.151 395.071 337.286 397.341",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M297.937 388.009C297.937 388.009 311.432 397.594 314.711 401.882",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M343.844 418.529C343.844 418.529 334.763 414.367 329.845 413.358C324.926 412.349 324.17 412.98 320.638 411.214",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M314.963 413.485C314.963 413.485 319.629 413.863 322.152 412.728",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M318.873 334.031C318.873 334.031 312.26 338.529 310.873 341.808C309.486 345.087 304.392 355.078 304.392 355.078L313.323 359.885C313.323 359.885 322.025 374.767 324.169 379.559C326.313 384.352 330.475 386.117 330.475 386.117C330.475 386.117 331.232 387.883 332.493 388.135C333.754 388.387 360.617 385.487 360.617 385.487C360.617 385.487 360.113 382.334 359.356 380.19C358.599 378.046 354.942 373.254 354.311 370.479C353.68 367.705 351.663 352.823 348.131 346.391C344.6 339.959 336.528 334.41 335.141 333.023C333.754 331.636 334.384 331.762 332.997 331.257C331.611 330.751 323.917 330.751 318.873 334.031Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M335.678 383.525C341.595 384.058 352.976 385.112 354.865 385.51",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M332.111 383.208C332.111 383.208 332.91 383.278 334.21 383.394",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M354.643 383.632L357.032 384.156",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M341.592 380.77L351.247 382.887",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M347.546 366.68C348.952 367.206 350.116 367.621 350.666 367.767",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M338.206 363.027C338.206 363.027 341.975 364.544 345.423 365.872",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M304.243 310.951C304.243 310.951 303.739 312.591 303.234 315.996C302.729 319.401 304.621 320.536 305 322.68C305.378 324.824 302.856 327.851 302.982 328.734C303.108 329.617 305.378 329.617 305.378 329.617C305.378 329.617 309.836 337.441 311.097 337.568C312.358 337.694 316.603 334.032 316.603 334.032L321.395 339.329C321.395 339.329 320.891 343.491 322.026 342.986C323.161 342.482 325.305 340.842 327.701 337.941C330.097 335.04 332.998 333.275 332.998 333.275C332.998 333.275 329.845 329.239 329.214 326.843C328.583 324.447 331.232 326.339 331.736 320.537C332.241 314.736 329.97 309.06 325.935 305.907C321.899 302.754 314.08 301.367 308.531 304.394C302.982 307.42 303.865 309.942 304.243 310.951Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M325.935 305.906C321.899 302.753 314.08 301.366 308.531 304.393C302.982 307.42 303.865 309.942 304.243 310.951C304.243 310.951 306.891 312.464 308.783 312.843C310.675 313.221 313.828 311.708 313.954 315.365C314.08 319.022 318.242 322.68 319.881 320.662C321.521 318.644 324.043 318.518 324.674 320.788C325.305 323.058 323.539 324.698 324.548 325.833C325.557 326.968 328.71 325.959 328.71 325.959C328.71 325.959 328.879 325.971 329.147 325.987C329.374 324.858 331.312 325.421 331.737 320.536C332.241 314.735 329.971 309.059 325.935 305.906Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M337.538 308.807C337.538 312.359 334.63 315.239 331.043 315.239C327.456 315.239 324.548 312.359 324.548 308.807C324.548 305.255 327.456 302.375 331.043 302.375C334.63 302.375 337.538 305.255 337.538 308.807Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M308.486 323.885C308.745 324.569 308.663 325.234 308.305 325.369C307.947 325.504 307.447 325.059 307.188 324.375C306.929 323.691 307.01 323.026 307.369 322.891C307.728 322.756 308.228 323.201 308.486 323.885Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M308.153 332.013C308.153 332.013 309.792 331.509 310.297 329.743",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M305.757 321.545C305.757 321.545 307.27 320.536 308.784 322.05",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M324.17 324.446C324.17 324.446 322.531 326.464 321.395 326.464C320.26 326.464 320.26 326.464 320.26 326.464",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M334.328 340.318C334.328 340.318 329.418 342.547 327.818 343.974C326.218 345.4 316.986 353.351 316.986 353.351L335.106 364.917L347.743 355.492",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M334.328 340.318C334.328 340.318 329.418 342.547 327.818 343.974C326.218 345.4 316.986 353.351 316.986 353.351L335.106 364.917L347.743 355.492",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M316.985 353.35L301.494 359.574C301.494 359.574 292.034 360.701 283.406 360.978C274.778 361.254 266.611 361.289 265.786 361.1C264.961 360.911 257.161 356.574 256.459 356.355C255.757 356.136 248.949 358.566 248.949 358.566C248.949 358.566 247.854 362.076 248.003 362.689C248.152 363.302 249.347 362.882 249.347 362.882C249.347 362.882 249.882 365.088 250.246 365.519C250.61 365.95 251.212 367.361 251.858 366.815C252.504 366.269 254.297 363.498 254.297 363.498C254.297 363.498 258.628 365.302 260.277 365.681C261.926 366.06 271.126 367.072 273.266 367.331C275.405 367.591 300.376 370.487 301.023 369.94C301.669 369.394 326.028 359.071 326.028 359.071L316.985 353.35Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M254.057 358.755L250.867 360.048L249.348 362.883",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M254.57 359.799L251.618 362.073L250.248 365.52",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M255.45 360.753L252.558 363.272L251.86 366.815",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M538.727 436.84V359.96",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M539.253 411.802L560.734 388.327",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M538.588 389.212L524.193 375.482",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M550.99 399.178L552.097 385.005",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M538.81 425.754L522.422 416.231",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M532.166 383.012L519.1 383.454",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M542.311 353.318C542.311 357.841 538.574 361.508 538.574 361.508C538.574 361.508 534.837 357.841 534.837 353.318C534.837 348.795 538.574 345.128 538.574 345.128C538.574 345.128 542.311 348.794 542.311 353.318Z",
    fill: "#3DE96E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M522.811 369.037C526.341 371.865 526.866 377.075 526.866 377.075C526.866 377.075 521.668 377.699 518.137 374.871C514.607 372.043 514.082 366.833 514.082 366.833C514.082 366.833 519.281 366.208 522.811 369.037Z",
    fill: "#3DE96E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M516.747 379.569C521.27 379.6 524.911 383.362 524.911 383.362C524.911 383.362 521.219 387.074 516.695 387.043C512.172 387.012 508.531 383.25 508.531 383.25C508.531 383.25 512.224 379.538 516.747 379.569Z",
    fill: "#3DE96E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M556.236 384.626C555.775 389.126 551.682 392.392 551.682 392.392C551.682 392.392 548.338 388.363 548.8 383.863C549.261 379.363 553.353 376.097 553.353 376.097C553.353 376.097 556.698 380.126 556.236 384.626Z",
    fill: "#3DE96E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M531.556 407.615C533.856 411.51 538.939 412.767 538.939 412.767C538.939 412.767 540.293 407.709 537.993 403.814C535.693 399.919 530.61 398.662 530.61 398.662C530.61 398.662 529.256 403.72 531.556 407.615Z",
    fill: "#3DE96E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M546.173 384.765C543.873 388.66 538.791 389.917 538.791 389.917C538.791 389.917 537.437 384.859 539.737 380.964C542.037 377.069 547.12 375.812 547.12 375.812C547.12 375.812 548.473 380.87 546.173 384.765Z",
    fill: "#3DE96E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M521.938 410.404C525.652 412.986 526.529 418.148 526.529 418.148C526.529 418.148 521.385 419.123 517.671 416.541C513.957 413.959 513.08 408.797 513.08 408.797C513.08 408.797 518.225 407.822 521.938 410.404Z",
    fill: "#3DE96E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M567.241 386.597C564.232 389.974 559.002 390.226 559.002 390.226C559.002 390.226 558.651 385.002 561.66 381.625C564.669 378.248 569.899 377.996 569.899 377.996C569.899 377.996 570.25 383.22 567.241 386.597Z",
    fill: "#3DE96E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M516.916 437.739C516.916 437.739 533.166 431.239 539.666 431.239C546.166 431.239 561.604 438.145 561.604 438.145L516.916 437.739Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M633.994 436.84V359.96",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M633.468 429.519L611.986 406.044",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M634.133 389.212L648.527 375.482",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M621.731 416.896L620.623 402.722",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M633.911 425.754L650.299 416.231",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M640.555 383.012L653.621 383.454",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M630.41 367.023C630.41 371.546 634.147 375.213 634.147 375.213C634.147 375.213 637.884 371.546 637.884 367.023C637.884 362.5 634.147 358.833 634.147 358.833C634.147 358.833 630.41 362.499 630.41 367.023Z",
    fill: "#3DE96E"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M649.91 369.037C646.38 371.865 645.855 377.075 645.855 377.075C645.855 377.075 651.054 377.699 654.584 374.871C658.114 372.043 658.639 366.833 658.639 366.833C658.639 366.833 653.44 366.208 649.91 369.037Z",
    fill: "#3DE96E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M655.974 379.569C651.451 379.6 647.81 383.362 647.81 383.362C647.81 383.362 651.502 387.074 656.026 387.043C660.549 387.012 664.19 383.25 664.19 383.25C664.19 383.25 660.497 379.538 655.974 379.569Z",
    fill: "#3DE96E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M634.341 394.639L619.946 380.909",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M627.919 388.439L614.853 388.881",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M618.564 374.464C622.094 377.292 622.619 382.502 622.619 382.502C622.619 382.502 617.421 383.126 613.89 380.298C610.36 377.47 609.835 372.26 609.835 372.26C609.835 372.26 615.034 371.635 618.564 374.464Z",
    fill: "#3DE96E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 384.996C617.023 385.027 620.664 388.789 620.664 388.789C620.664 388.789 616.972 392.501 612.448 392.47C607.925 392.439 604.284 388.677 604.284 388.677C604.284 388.677 607.977 384.965 612.5 384.996Z",
    fill: "#3DE96E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M616.485 402.344C616.946 406.844 621.038 410.11 621.038 410.11C621.038 410.11 624.382 406.081 623.92 401.581C623.459 397.081 619.367 393.815 619.367 393.815C619.367 393.815 616.023 397.844 616.485 402.344Z",
    fill: "#3DE96E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M641.684 396.919C637.37 398.28 632.749 395.819 632.749 395.819C632.749 395.819 635.122 391.152 639.435 389.791C643.749 388.43 648.37 390.891 648.37 390.891C648.37 390.891 645.998 395.558 641.684 396.919Z",
    fill: "#3DE96E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M650.782 410.404C647.068 412.986 646.191 418.148 646.191 418.148C646.191 418.148 651.335 419.123 655.049 416.541C658.763 413.959 659.64 408.797 659.64 408.797C659.64 408.797 654.496 407.822 650.782 410.404Z",
    fill: "#3DE96E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M605.48 404.314C608.489 407.691 613.719 407.943 613.719 407.943C613.719 407.943 614.07 402.719 611.061 399.342C608.052 395.965 602.822 395.713 602.822 395.713C602.822 395.713 602.471 400.937 605.48 404.314Z",
    fill: "#3DE96E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M610.76 437.739C610.76 437.739 627.01 431.239 633.51 431.239C640.01 431.239 655.448 438.145 655.448 438.145L610.76 437.739Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M248.292 436.84V359.96",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M248.818 411.802L270.3 388.327",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M248.154 389.212L233.759 375.482",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M260.556 399.178L261.663 385.005",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M248.375 425.754L231.987 416.231",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M241.732 383.012L228.665 383.454",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M251.877 353.318C251.877 357.841 248.14 361.508 248.14 361.508C248.14 361.508 244.403 357.841 244.403 353.318C244.403 348.795 248.14 345.128 248.14 345.128C248.14 345.128 251.877 348.794 251.877 353.318Z",
    fill: "#3DE96E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M232.376 369.037C235.906 371.865 236.431 377.075 236.431 377.075C236.431 377.075 231.232 377.699 227.702 374.871C224.172 372.043 223.647 366.833 223.647 366.833C223.647 366.833 228.846 366.208 232.376 369.037Z",
    fill: "#3DE96E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M226.312 379.569C230.835 379.6 234.477 383.362 234.477 383.362C234.477 383.362 230.785 387.074 226.261 387.043C221.738 387.012 218.097 383.25 218.097 383.25C218.097 383.25 221.789 379.538 226.312 379.569Z",
    fill: "#3DE96E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M265.802 384.626C265.341 389.126 261.249 392.392 261.249 392.392C261.249 392.392 257.905 388.363 258.367 383.863C258.829 379.363 262.92 376.097 262.92 376.097C262.92 376.097 266.263 380.126 265.802 384.626Z",
    fill: "#3DE96E"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M241.122 407.615C243.422 411.51 248.504 412.767 248.504 412.767C248.504 412.767 249.858 407.709 247.558 403.814C245.258 399.919 240.176 398.662 240.176 398.662C240.176 398.662 238.822 403.72 241.122 407.615Z",
    fill: "#3DE96E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M255.739 384.765C253.439 388.66 248.357 389.917 248.357 389.917C248.357 389.917 247.003 384.859 249.303 380.964C251.603 377.069 256.686 375.812 256.686 375.812C256.686 375.812 258.039 380.87 255.739 384.765Z",
    fill: "#3DE96E"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M231.504 410.404C235.218 412.986 236.095 418.148 236.095 418.148C236.095 418.148 230.951 419.123 227.237 416.541C223.523 413.959 222.646 408.797 222.646 408.797C222.646 408.797 227.79 407.822 231.504 410.404Z",
    fill: "#3DE96E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M276.807 386.597C273.798 389.974 268.568 390.226 268.568 390.226C268.568 390.226 268.217 385.002 271.226 381.625C274.235 378.248 279.465 377.996 279.465 377.996C279.465 377.996 279.816 383.22 276.807 386.597Z",
    fill: "#3DE96E"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M226.039 437.739C226.039 437.739 242.289 431.239 248.789 431.239C255.289 431.239 270.727 438.145 270.727 438.145L226.039 437.739Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M189.316 389.494C189.316 389.494 174.886 409.501 175.321 410.51C175.755 411.519 181.908 415.807 188.48 418.479C195.053 421.151 204.965 419.913 211.538 416.844C211.538 416.844 211.848 407.409 201.859 396.771C195.674 390.186 189.316 389.494 189.316 389.494Z",
    fill: "#ADADAD",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M206.515 408.489C206.515 408.489 202.964 407.669 201.598 409.035C200.232 410.401 198.866 413.406 199.686 414.498C200.506 415.591 201.598 417.23 201.598 417.23C201.598 417.23 198.866 416.957 198.866 419.142C198.866 421.327 197.227 425.152 200.505 427.61C203.783 430.068 206.515 426.517 207.334 425.971C208.154 425.425 208.427 421.874 208.427 421.874C208.427 421.874 211.705 421.601 212.798 419.415C213.891 417.23 214.437 414.498 212.525 411.493C210.613 408.489 206.515 408.489 206.515 408.489Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M210.34 425.152C210.34 425.152 205.15 430.342 206.516 431.435C207.882 432.528 211.16 434.44 211.16 434.44C211.16 434.44 214.438 434.44 214.984 431.982C215.53 429.524 216.077 427.611 214.711 426.519C213.344 425.426 213.344 424.333 210.34 425.152Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M211.159 434.44C211.159 434.44 206.242 435.533 204.33 436.352C202.418 437.171 199.413 437.718 199.413 437.718H233.012C233.012 437.718 231.919 433.894 228.914 433.347C225.909 432.801 218.807 434.166 218.807 434.166C218.807 434.166 217.988 432.527 214.983 431.981C211.979 431.435 211.159 434.44 211.159 434.44Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M202.691 432.664C202.691 433.343 202.141 433.893 201.462 433.893C200.783 433.893 200.233 433.343 200.233 432.664C200.233 431.985 200.783 431.435 201.462 431.435C202.141 431.435 202.691 431.986 202.691 432.664Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M198.32 425.972C198.32 427.179 197.342 428.157 196.135 428.157C194.928 428.157 193.95 427.179 193.95 425.972C193.95 424.765 194.928 423.787 196.135 423.787C197.342 423.787 198.32 424.765 198.32 425.972Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M157.614 427.6C157.614 427.6 162.841 432.575 164.292 433.493C165.743 434.411 168.839 435.757 168.539 438.078C168.239 440.399 160.8 441.978 159.221 440.385C157.642 438.792 145.042 434.23 144.609 433.036C144.176 431.842 145.132 429.726 145.132 429.726L156.419 428.033L157.614 427.6Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M146.608 333.776C146.608 333.776 155.398 372.859 155.607 380.888C155.816 388.917 154.08 416.375 154.08 416.375C154.08 416.375 157.999 423.781 158.128 424.456C158.256 425.131 157.652 426.934 157.614 427.6C157.614 427.6 144.206 431.343 142.865 431.434C141.524 431.524 139.36 431.401 139.36 431.401C139.36 431.401 138.114 418.135 136.863 413.722C135.612 409.308 130.722 383.809 130.722 383.809L120.286 355.989C120.286 355.989 115.639 340.859 114.83 337.472C114.021 334.085 114.83 325.781 114.83 325.781C114.83 325.781 134.926 327.764 138.698 328.982C142.47 330.2 146.608 333.776 146.608 333.776Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M145.134 429.726C145.134 429.726 147.712 431.376 150.181 432.019C152.65 432.661 160.193 435.096 160.45 436.447C160.707 437.798 159.936 439.591 159.223 440.385C158.51 441.179 152.126 441.817 147.789 441.736C143.451 441.655 136.093 438.896 134.947 438.497C133.801 438.097 132.008 437.327 132.008 437.327C132.008 437.327 142.813 429.427 145.134 429.726Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M141.071 342.98L135.944 345.025L135.782 347.855L141.447 374.4C141.447 374.4 141.775 383.271 142.446 386.148C143.117 389.025 144.168 420.318 144.168 420.318C144.168 420.318 146.798 423.976 147.103 424.494C147.407 425.012 147.455 430.026 147.455 430.026C147.455 430.026 137.524 434.302 134.746 436.148C131.968 437.993 130.85 437.094 130.85 437.094C130.85 437.094 127.245 435.886 126.764 435.524C126.284 435.163 126.269 432.489 126.269 432.489C126.269 432.489 120.081 403.408 119.21 398.181C118.339 392.954 115.952 376.283 115.952 376.283C115.952 376.283 107.457 343.73 106.767 341.186C106.077 338.641 106.163 325.452 106.163 325.452C106.163 325.452 123.547 328.115 127.21 328.325C130.872 328.534 141.864 332.002 141.864 332.002L142.982 332.901",
    fill: "#263238"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M141.071 342.98L135.944 345.025L135.782 347.855L141.447 374.4C141.447 374.4 141.775 383.271 142.446 386.148C143.117 389.025 144.168 420.318 144.168 420.318C144.168 420.318 146.798 423.976 147.103 424.494C147.407 425.012 147.455 430.026 147.455 430.026C147.455 430.026 137.524 434.302 134.746 436.148C131.968 437.993 130.85 437.094 130.85 437.094C130.85 437.094 127.245 435.886 126.764 435.524C126.284 435.163 126.269 432.489 126.269 432.489C126.269 432.489 120.081 403.408 119.21 398.181C118.339 392.954 115.952 376.283 115.952 376.283C115.952 376.283 107.457 343.73 106.767 341.186C106.077 338.641 106.163 325.452 106.163 325.452C106.163 325.452 123.547 328.115 127.21 328.325C130.872 328.534 141.864 332.002 141.864 332.002L142.982 332.901",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M139.671 346.562L133.638 349.046C133.638 349.046 142.381 383.504 142.446 386.148C142.511 388.792 142.865 423.925 142.865 423.925",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M172.908 278.798C172.908 278.798 160.105 274.809 157.873 274.681C155.641 274.553 145.708 273.782 140.223 277.134C134.738 280.485 118.688 297.689 113.806 304.74C108.924 311.791 105.045 326.228 105.045 326.228C105.045 326.228 116.665 329.539 119.709 329.713C122.753 329.887 130.239 330.722 130.239 330.722C130.239 330.722 137.707 335.424 143.389 335.749C149.071 336.074 143.667 338.004 154.017 331.47C164.367 324.935 171.035 322.262 171.035 322.262L163.677 333.447C163.677 333.447 166.344 336.653 169.748 337.662C173.152 338.671 179.53 341.071 179.53 341.071C179.53 341.071 183.421 326.43 185.073 322.453C186.725 318.475 188.958 311.477 188.772 307.598C188.586 303.719 186.279 294.221 186.279 294.221C186.279 294.221 176.897 280.248 172.908 278.798Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M129.239 321.388C130.155 323.448 131.179 325.304 132.244 326.441",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M125.426 310.19C125.426 310.19 126.396 313.975 127.882 318.016",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M120.095 316.341C120.095 316.341 124.544 325.633 129.103 329.766",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M165.855 312.573L176.214 312.663L177.332 306.059L180.323 308.823L180.798 300.515L180.45 293.642L173.287 302.308L165.855 312.573Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M176.65 279.927C176.65 279.927 184.858 273.029 189.62 271.738C194.382 270.447 200.733 272.596 202.622 274.713C204.51 276.83 206.201 286.303 206.271 288.986C206.341 291.669 205.953 294.549 204.122 295.337C202.291 296.125 199.703 298.433 198.801 298.605C197.898 298.777 196.341 298.688 196.341 298.688L194.726 303.507L190.536 302.598C190.536 302.598 182.506 306.381 181.406 306.095C180.306 305.809 176.828 300.252 176.828 300.252C176.828 300.252 175.073 307.519 172.746 309.172C170.419 310.825 165.854 312.573 165.854 312.573C165.854 312.573 170.412 307.029 172.097 297.079C173.783 287.13 176.65 279.927 176.65 279.927Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M202.621 274.713C200.733 272.596 194.382 270.447 189.62 271.738C184.858 273.029 176.65 279.927 176.65 279.927C176.65 279.927 175.518 284.104 177.063 284.416C178.608 284.728 178.608 284.728 178.608 284.728C178.608 284.728 182.397 280.926 183.631 282.782C184.864 284.638 186.11 286.272 185.379 287.347C184.648 288.421 183.408 290.583 183.408 290.583L184.928 291.34L187.948 289.28L190.307 290.978L194.859 289.452C194.859 289.452 199.379 292.389 201.751 293.864C202.909 294.584 203.926 294.917 204.808 294.877C206.047 293.732 206.331 291.292 206.271 288.988C206.201 286.303 204.509 276.83 202.621 274.713Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M196.141 297.388C196.141 297.388 195.147 295.794 193.539 295.43",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M194.312 297.735L193.003 298.474C193.003 298.474 192.207 298.157 191.823 296.959",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M186.494 300.002C186.494 300.002 186.257 300.983 187.092 302.207",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M176.828 300.252L176.799 295.223",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M178.608 284.727C178.608 284.727 177.287 286.675 177.38 288.053C177.473 289.43 179.133 290.383 179.133 290.383",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M178.608 284.727C178.608 284.727 177.287 286.675 177.38 288.053C177.473 289.43 179.133 290.383 179.133 290.383",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M177.037 278.815L173.603 277.322L163.265 296.179L170.95 301.064L177.037 278.815Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M170.95 301.064L163.507 304.899L165.854 312.574C165.854 312.574 170.729 304.94 170.95 301.064Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M120.938 293.949C120.938 293.949 106.871 304.954 105.967 306.531C105.063 308.108 93.9879 338.016 93.9879 338.016C93.9879 338.016 92.1329 341.982 92.4569 343.426C92.7819 344.87 95.4029 348.888 96.1909 349.34C96.9789 349.792 100.464 349.381 101.775 347.827C103.085 346.273 104.454 343.704 104.378 341.46C104.303 339.216 102.998 337.106 102.998 337.106L102.923 334.862L120.416 310.208L128.789 306.207L120.938 293.949Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M151.048 276.531C151.048 276.531 142.751 275.65 137.503 278.404C132.256 281.158 119.528 293.665 119.528 293.665C119.528 293.665 120.612 299.631 122.694 302.397C124.776 305.163 129.82 309.523 129.82 309.523C129.82 309.523 147.163 301.759 151.761 296.117",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M151.048 276.531C151.048 276.531 142.751 275.65 137.503 278.404C132.256 281.158 119.528 293.665 119.528 293.665C119.528 293.665 120.612 299.631 122.694 302.397C124.776 305.163 129.82 309.523 129.82 309.523C129.82 309.523 147.163 301.759 151.761 296.117",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M114.698 354.792C114.649 354.789 114.599 354.783 114.549 354.773C114.267 354.716 113.733 354.682 113.057 354.639C111.359 354.53 108.519 354.349 103.978 353.516C97.2772 352.287 95.5312 350.212 95.3542 349.98C95.0772 349.617 95.0662 349.116 95.3272 348.741L104.391 335.703C104.618 335.377 105.009 335.206 105.403 335.261C107.744 335.592 112.236 339.544 113.986 342.814C115.622 345.871 117.318 349.982 117.389 350.156C117.508 350.443 117.493 350.768 117.35 351.043L115.692 354.229C115.498 354.598 115.106 354.815 114.698 354.792ZM97.6032 349.154C98.4642 349.725 100.427 350.722 104.357 351.443C108.776 352.253 111.54 352.43 113.191 352.536C113.568 352.56 113.886 352.58 114.161 352.604L115.253 350.506C114.764 349.349 113.405 346.193 112.128 343.806C110.709 341.154 107.405 338.286 105.686 337.528L97.6032 349.154Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M114.757 353.74L184.733 403.667C184.733 403.667 197.35 409.637 196.136 407.927C194.922 406.217 187.882 400.238 187.092 399.701C186.302 399.164 116.415 350.554 116.415 350.554L114.757 353.74Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 397.059L184.733 403.667C184.733 403.667 197.35 409.637 196.136 407.927C194.922 406.217 187.882 400.238 187.092 399.701C186.919 399.583 183.408 397.143 178.038 393.41L175.471 397.059Z",
    fill: "#ADADAD",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M162.32 388.28C162.32 388.28 162.68 390.597 164.894 392.036C167.108 393.475 168.837 391.933 168.837 391.933L162.32 388.28Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M166.911 371.765L176.547 339.973C174.426 339.205 171.633 338.221 169.748 337.662C167.668 337.045 165.867 335.61 164.778 334.586C163.601 338.661 160.647 349.053 160.53 351.112C160.383 353.686 160.73 373.441 160.73 373.441C160.73 373.441 159.233 377.044 159.548 377.985C159.863 378.925 161.077 380.286 161.077 380.286C161.077 380.286 160.94 382.676 160.499 383.942C160.058 385.208 160.289 387.619 161.434 386.947C162.579 386.275 164.881 384.009 164.881 384.009L171.084 388.421C171.084 388.421 169.349 380.759 168.934 378.338C168.519 375.915 166.911 371.765 166.911 371.765Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5649 343.224C98.5649 343.224 99.4859 348.601 100.423 348.927C101.36 349.254 103.883 350.49 103.576 348.698C103.269 346.906 103.269 346.906 103.269 346.906C103.269 346.906 105.083 343.092 104.378 341.461C103.673 339.83 102.095 338.784 102.095 338.784",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5649 343.224C98.5649 343.224 99.4859 348.601 100.423 348.927C101.36 349.254 103.883 350.49 103.576 348.698C103.269 346.906 103.269 346.906 103.269 346.906C103.269 346.906 105.083 343.092 104.378 341.461C103.673 339.83 102.095 338.784 102.095 338.784",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector4.25ac8ca726ac0246d8e5e146cd5d9df1.svg";
export { ForwardRef as ReactComponent };